import React from 'react';

const TwitterIconX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="35"
    height="33"
    viewBox="0 0 35 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.818359" y="0.871094" width="33.9999" height="32" rx="16" fill="#069169" />
    <path
      d="M24.9681 12.8586C24.9795 13.0336 24.9795 13.2086 24.9795 13.3836C24.9795 18.7211 21.2676 24.8711 14.4833 24.8711C12.3932 24.8711 10.4516 24.2086 8.81836 23.0586C9.11532 23.0961 9.40083 23.1086 9.70922 23.1086C11.4338 23.1086 13.0214 22.4711 14.2892 21.3836C12.6673 21.3461 11.3082 20.1836 10.8399 18.5836C11.0684 18.6211 11.2968 18.6461 11.5366 18.6461C11.8678 18.6461 12.1991 18.5961 12.5074 18.5086C10.8171 18.1336 9.54929 16.5086 9.54929 14.5461V14.4961C10.0404 14.7961 10.6115 14.9836 11.2168 15.0086C10.2231 14.2836 9.57214 13.0461 9.57214 11.6461C9.57214 10.8961 9.75485 10.2086 10.0747 9.60857C11.8907 12.0586 14.6204 13.6585 17.6813 13.8336C17.6242 13.5336 17.5899 13.2211 17.5899 12.9086C17.5899 10.6836 19.2346 8.87109 21.279 8.87109C22.3411 8.87109 23.3005 9.35859 23.9744 10.1461C24.8081 9.9711 25.6076 9.63358 26.3158 9.1711C26.0416 10.1086 25.4591 10.8961 24.6939 11.3961C25.4363 11.3086 26.1559 11.0836 26.8183 10.7711C26.3158 11.5711 25.6876 12.2835 24.9681 12.8586Z"
      fill="white"
    />
  </svg>
);

export default TwitterIconX;
